/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('song-recommendations', require('./components/SongRecommendations.vue').default);
Vue.component('topic-recommendations', require('./components/TopicOfTheDayRecommendations.vue').default);
Vue.component('note-card', require('./components/NoteCard.vue').default);
Vue.component('weather-widget', require('./components/WeatherWidget.vue').default);
Vue.component('add-to-calendar-button', require('./components/AddToCalendarButton.vue').default);
Vue.component('import-statement-button', require('./components/ImportStatementButton.vue').default);
Vue.component('accounting-charts', require('./components/AccountingCharts.vue').default);
Vue.component('transaction-list', require('./components/TransactionList.vue').default);
Vue.component('bank-balance-cards', require('./components/BankBalanceCards.vue').default);

// Custom directives
Vue.directive('put-value-to-api', require("./directives/PutValueToApi.js").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
